import { useState } from "react";
import Modal from "../Modals/Modal/Modal.jsx";
import { BsPlusLg } from "react-icons/bs";
import ServiceBookingModal from "../Modals/ServiceBookingModal/ServiceBookingModal.jsx";
import css from "./NewServiceBookingBtn.module.css";

import Tooltip from "../sharedComponents/Tooltip/Tooltip.jsx";
import useTooltip from "../../utils/useTooltip.jsx";
import { getServiceDataForBooking } from "../../redux/crm/operations.js";
import { useDispatch } from "react-redux";
import { useTour } from "@reactour/tour";
import { useSelector } from "react-redux";
import {
  selectOpenTutorial,
  selectTutorialPage,
} from "../../redux/settings/selectors.js";
import { useCan } from "../../utils/permissions.js";
import { showToast } from "../../utils/showToast.js";

export default function NewServiceBookingBtn() {
  const [modalIsOpen, setIsOpen] = useState(false);
  const {
    tooltipPosition,
    isTooltipVisible,
    setIsTooltipVisible,
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
    handleClick,
  } = useTooltip();
  const dispatch = useDispatch();
  const { currentStep } = useTour();
  const part = useSelector(selectTutorialPage);
  const isTutorialOpen = useSelector(selectOpenTutorial);

  const can = useCan();

  const today = new Date().toLocaleDateString();
  const dateToPass = today.split(".").reverse().join("-");

  const openModal = () => {
    if (!can("records", "create")) {
      showToast("У вас немає прав для створення запису", "error");
      return;
    }

    if (!modalIsOpen) {
      // Перевірка, чи модалка вже відкрита
      setIsTooltipVisible(false);
      // dispatch(getServiceDataForBooking(dateToPass))
      //   .unwrap()
      //   .then(() => setIsOpen(true));
      setIsOpen(true);
    }
  };

  const handleModalClose = () => {
    setIsOpen(false);
  };

  return (
    <div
      className={css.tooltip}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <button
        className={`${css.btn} ${
          (currentStep === 0 || currentStep === 1) &&
          part === "create-record" &&
          isTutorialOpen
            ? css.tourBorder
            : ""
        }`}
        onClick={openModal}
      >
        <BsPlusLg className={css.icon} />
      </button>
      {modalIsOpen && (
        <Modal isOpen={modalIsOpen} onClose={handleModalClose}>
          <ServiceBookingModal onClose={handleModalClose} />
        </Modal>
      )}

      {isTooltipVisible && !modalIsOpen && (
        <Tooltip
          isVisible={isTooltipVisible}
          position={tooltipPosition}
          text="Створити запис"
        />
      )}
    </div>
  );
}
